/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.commerce.buyer.portal.rpc.PublicPortalSettingsRpc
 */

export const getSettingsRpc = {
  serviceName: 'com.hubspot.commerce.buyer.portal.rpc.PublicPortalSettingsRpc',
  rpcName: 'getSettings',
  auth: 'external',
  fingerprint: 'XyWuE3G4XyT5xMv7IehS3LYD5Evuxlnt',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};